(function(){
  // Scroll reveal
  var revs=document.querySelectorAll('.rev');
  if(revs.length){
    var ro=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting)x.target.classList.add('on')});},{threshold:.08});
    revs.forEach(function(r){ro.observe(r)});
  }

  // Sticky bar
  var sticky=document.getElementById('lx-sticky');
  var hero=document.getElementById('lx-hero');
  if(sticky&&hero){
    var ho=new IntersectionObserver(function(e){sticky.classList.toggle('on',!e[0].isIntersecting)},{threshold:.1});
    ho.observe(hero);
  }

  // Add to cart
  window.lxAdd=function(id,btn){
    var orig=btn?btn.textContent:'';
    if(btn){btn.textContent='...';btn.disabled=true}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(id),quantity:1})})
      .then(function(r){return r.json()})
      .then(function(){
        if(btn){btn.textContent='✓';setTimeout(function(){btn.textContent=orig;btn.disabled=false},1500)}
        var b=document.querySelector('.cart-badge');
        if(b)b.textContent=parseInt(b.textContent||0)+1;
      }).catch(function(){if(btn){btn.textContent=orig;btn.disabled=false}});
  };

  // Cart qty
  window.lxQty=function(key,qty){
    if(qty<0)return;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(){window.location.reload()});
  };

  // Product thumb switcher
  document.querySelectorAll('.prod-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      var src=this.dataset.src;
      var main=document.getElementById('main-img');
      if(main&&src)main.src=src;
      document.querySelectorAll('.prod-thumb').forEach(function(x){x.classList.remove('on')});
      this.classList.add('on');
    });
  });

  // Variant selector
  document.querySelectorAll('.var-btn').forEach(function(b){
    b.addEventListener('click',function(){
      this.closest('.var-btns').querySelectorAll('.var-btn').forEach(function(x){x.classList.remove('on')});
      this.classList.add('on');
    });
  });
})();
